import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SignupService } from '@app/services/signup.service';
import { base64ToBlob } from '@app/shared/utils';

@Component({
  selector: 'app-instructions',
  template: ``
})
export class InstructionsComponent implements OnInit {
  constructor(
    private signupService: SignupService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.signupService
      .getSignupInstructions()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(bite => {
        const blob = base64ToBlob(bite, 'application/pdf');
        const url = URL.createObjectURL(blob);
        window.open(url, '_self');
      });
  }
}
